var Forms = require('../forms/forms');
new Forms();

let formSubmitter = require('../forms/form_submitter');
formSubmitter();



// WEBPACK FOOTER //
// ./src/javascripts/platform/initializers/forms.initializer.js